import { render, staticRenderFns } from "./legendBox15.vue?vue&type=template&id=c1ed20c6&scoped=true&"
import script from "./legendBox15.vue?vue&type=script&lang=js&"
export * from "./legendBox15.vue?vue&type=script&lang=js&"
import style0 from "./legendBox15.vue?vue&type=style&index=0&id=c1ed20c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ed20c6",
  null
  
)

export default component.exports